import { render, staticRenderFns } from "./examine.vue?vue&type=template&id=487e7f72&scoped=true"
import script from "./examine.vue?vue&type=script&lang=ts"
export * from "./examine.vue?vue&type=script&lang=ts"
import style1 from "./examine.vue?vue&type=style&index=1&id=487e7f72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487e7f72",
  null
  
)

export default component.exports